module.exports = __webpack_public_path__ + "static/media/workloads-activity-stream.4a7f1705.png";